module.exports = __webpack_public_path__ + "static/media/w_inner_logo_white.17f74b6f.svg";